import React from 'react';
import { Page } from '../Page';
export function DividerLookingAhead() {
  return <Page hideFooter variant="dark" data-id="element-639" data-mp="3kzqxd5cpzvl">
      <div className="flex flex-col h-full justify-center items-center text-center" data-id="element-640" data-mp="3m11lgiggkcs">
        <p className="text-[10px] font-bold text-lightteal uppercase tracking-[0.25em] mb-4" data-id="element-641" data-mp="3uym1e4sbwaxw">
          Part Six
        </p>
        <h1 className="text-5xl font-serif text-white leading-tight mb-6" data-id="element-642" data-mp="3pzsu4u3mxg66">
          Looking Ahead
        </h1>
        <div className="w-16 h-0.5 bg-tealslate" data-id="element-643" data-mp="3l2iyuxtkeaaf" />
      </div>
    </Page>;
}